import { createViewStmtInstruction } from './CreateViewStmt';
import { removeViewStmtInstruction } from './RemoveViewStmt';
import { renameViewStmtInstruction } from './RenameViewStmt';
export const viewInstruction = `
## View
- Description: Represent individual screens or pages in the user interface.

### View commands

${createViewStmtInstruction}
${removeViewStmtInstruction}
${renameViewStmtInstruction}
`;
//# sourceMappingURL=viewInstruction.js.map